@if (cardDetails) {
  <app-replace-card
    [cardDetails]="cardDetails"
    [cardType]="cardType" />
}
